// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.notification-margin[data-v-292fe336]{margin-bottom:.75rem\n}", "",{"version":3,"sources":["webpack://./../nn-psdl-modules/src/app-coupleEherkenning/views/Home.vue"],"names":[],"mappings":";AACA,sCAAsC;AACtC","sourcesContent":["\n.notification-margin[data-v-292fe336]{margin-bottom:.75rem\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
